import { render, staticRenderFns } from "./TinyMceEditComponent.vue?vue&type=template&id=2c69c615"
import script from "./TinyMceEditComponent.vue?vue&type=script&lang=js"
export * from "./TinyMceEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports